// import React, { useEffect, useRef, useState } from "react";
// import { Pressable, PressableProps, ViewStyle } from "react-native";

// export interface PressableWrappProps {
//   children: any;
//   activeOpacity?: number;
//   PressableProps?: PressableProps;
//   onPress?: () => any;
//   style?: ViewStyle;
// }

// const PressableWrapp: React.FC<PressableWrappProps> = ({
//   children,
//   style = {},
//   activeOpacity = 0.8,
//   onPress,
//   PressableProps,
// }) => {
//   const [opacity, setOpacity] = useState(1);
//   const [pressed, setPressed] = useState(false);

//   const interval = useRef<number | null>(null);
//   const ref = useRef<any>(null);

//   // твоя логика opacity
//   useEffect(() => {
//     if (pressed) {
//       setOpacity(activeOpacity);
//       setPressed(false);

//       if (interval.current) clearInterval(interval.current);

//       interval.current = window.setInterval(() => {
//         setOpacity(1);
//         if (interval.current) clearInterval(interval.current);
//       }, 300);
//     }

//     return () => {
//       if (interval.current) clearInterval(interval.current);
//     };
//   }, [pressed, activeOpacity]);

//   // ✅ middle mouse (auxclick)
//   useEffect(() => {
//     const node = ref.current;

//     if (!node || typeof node.addEventListener !== "function") return;

//     const handler = (e: MouseEvent) => {
//       // middle button
//       if (e.button === 1) {
//         e.preventDefault(); // убираем autoscroll
//         onPress?.();
//       }
//     };

//     node.addEventListener("auxclick", handler);
//     // fallback: если где-то auxclick не поддерживается
//     node.addEventListener("mousedown", handler);

//     return () => {
//       node.removeEventListener("auxclick", handler);
//       node.removeEventListener("mousedown", handler);
//     };
//   }, [onPress]);

//   return (
//     <Pressable
//       ref={ref}
//       style={[{ opacity }, style ?? {}]}
//       onPress={() => {
//         setPressed(true);
//         onPress?.();
//       }}
//       {...PressableProps}
//     >
//       {children}
//     </Pressable>
//   );
// };

// export default PressableWrapp;



// import React, { useEffect, useRef, useState } from "react";
// import { Pressable, PressableProps, ViewStyle } from "react-native";

// export interface PressableWrappProps {
//   children: any;
//   activeOpacity?: number;
//   PressableProps?: PressableProps;
//   onPress?: () => any;
//   style?: ViewStyle;
// }

// const PressableWrapp: React.FC<PressableWrappProps> = ({
//   children,
//   style = {},
//   activeOpacity = 0.8,
//   onPress,
//   PressableProps,
// }) => {
//   const [opacity, setOpacity] = useState(1);
//   const [pressed, setPressed] = useState(false);

//   const interval = useRef<number | null>(null);

//   // opacity animation (left click only)
//   useEffect(() => {
//     if (pressed) {
//       setOpacity(activeOpacity);
//       setPressed(false);

//       if (interval.current) clearInterval(interval.current);

//       interval.current = window.setTimeout(() => {
//         setOpacity(1);
//       }, 300);
//     }

//     return () => {
//       if (interval.current) clearTimeout(interval.current);
//     };
//   }, [pressed, activeOpacity]);

//   return (
//     <Pressable
//       style={[{ opacity }, style ?? {}]}
//       onPress={() => {
//         // 🔹 left click / tap only
//         setPressed(true);
//         onPress?.();
//       }}
//       {...PressableProps}
//     >
//       {children}
//     </Pressable>
//   );
// };

// export default PressableWrapp;


import React, { useEffect, useRef, useState } from "react";
import { Pressable, PressableProps, StyleProp, ViewStyle } from "react-native";

export interface PressableWrappProps
  extends Omit<PressableProps, "children" | "style" | "onPress"> {
  children?: React.ReactNode;
  activeOpacity?: number;
  onPress?: () => any;

  /** middle-click handler (web) */
  onMiddlePress?: () => any;

  style?: StyleProp<ViewStyle>;
}

const PressableWrapp = React.forwardRef<any, PressableWrappProps>(({
  children,
  style = {},
  activeOpacity = 0.8,
  onPress,
  onMiddlePress,
  ...restProps
}, forwardedRef) => {
  const [opacity, setOpacity] = useState(1);
  const [pressed, setPressed] = useState(false);

  const interval = useRef<number | null>(null);
  const ref = useRef<any>(null);

  const setRefs = (node: any) => {
    ref.current = node;

    if (typeof forwardedRef === "function") {
      forwardedRef(node);
      return;
    }

    if (forwardedRef && "current" in forwardedRef) {
      forwardedRef.current = node;
    }
  };

  // opacity animation (left click only)
  useEffect(() => {
    if (pressed) {
      setOpacity(activeOpacity);
      setPressed(false);

      if (interval.current) clearTimeout(interval.current);

      interval.current = window.setTimeout(() => {
        setOpacity(1);
      }, 300);
    }

    return () => {
      if (interval.current) clearTimeout(interval.current);
    };
  }, [pressed, activeOpacity]);

  // ✅ middle mouse support for web
  useEffect(() => {
    if (!onMiddlePress) return;

    const node = ref.current;

    // RN native: тут node не DOM и addEventListener не будет
    if (!node || typeof node.addEventListener !== "function") return;

    const handler = (e: MouseEvent) => {
      // middle button only
      if (e.button !== 1) return;

      // блокируем автоскролл/дефолт и чужие обработчики
      e.preventDefault();
      e.stopPropagation();
      // @ts-ignore
      e.stopImmediatePropagation?.();

      // optional opacity animation for middle too (если хочешь)
      // setOpacity(activeOpacity);
      // window.setTimeout(() => setOpacity(1), 300);

      // ВАЖНО: middle НЕ должен вызывать onPress
      onMiddlePress?.();
    };

    // auxclick — наиболее корректно для middle; capture чтобы перехватить раньше
    node.addEventListener("auxclick", handler, true);

    return () => {
      node.removeEventListener("auxclick", handler, true);
    };
  }, [onMiddlePress]);

  return (
    <Pressable
      ref={setRefs}
      style={[{ opacity }, style ?? {}]}
      onPress={() => {
        // 🔹 left click / tap only
        setPressed(true);
        onPress?.();
      }}
      {...restProps}
    >
      {children}
    </Pressable>
  );
});

export default PressableWrapp;
